import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-b2-list',
  templateUrl: './b2-list.component.html',
  styleUrl: './b2-list.component.css'
})
export class B2ListComponent implements OnInit {
  displayedColumns: string[] = [
    'clientName', 'contactPerson', 'contactNo', 'district', 'tehsil', 'village', 'khasraNo', 'area',
    'entryDate', 'category', 'ecMp', 'rqp', 'leaseValidity', 'mpPeriod', 'blasting', 'mineral',
    'fileStatus', 'filePreparedBy', 'productionDetails', 'onlineDate', 'proposalNo', 'caseNo',
    'seacDate', 'pptStatus', 'seacMinutes', 'seacAdsStatus', 'seacAdsDate', 'seiaaDate',
    'pptApproved', 'seiaaAdsStatus', 'seiaaAgendaDate', 'seiaaMinutes', 'ecStatus', 'folderLink',
    'kml', 'remark','actions'
  ];

  columnLabels: { [key: string]: string } = {
    clientName: 'Client Name',
    contactPerson: 'Contact Person',
    contactNo: 'Contact No.',
    district: 'District',
    tehsil: 'Tehsil',
    village: 'Village',
    khasraNo: 'Khasra No.',
    area: 'Area',
    entryDate: 'Entry Date',
    category: 'Category',
    ecMp: 'EC/MP',
    rqp: 'RQP',
    leaseValidity: 'Lease Validity',
    mpPeriod: 'MP Period',
    blasting: 'Blasting',
    mineral: 'Mineral',
    fileStatus: 'File Status',
    filePreparedBy: 'File Prepared By',
    productionDetails: 'Production Details',
    onlineDate: 'Online Date',
    proposalNo: 'Proposal No',
    caseNo: 'Case No',
    seacDate: 'SEAC Agenda Date',
    pptStatus: 'PPT Status',
    seacMinutes: 'SEAC Minutes',
    seacAdsStatus: 'SEAC ADS Status',
    seacAdsDate: 'SEAC ADS Date',
    seiaaDate: 'SEIAA Agenda Date',
    pptApproved: 'PPT Approved',
    seiaaAdsStatus: 'SEIAA ADS Status',
    seiaaAgendaDate: 'SEIAA Agenda Date',
    seiaaMinutes: 'SEIAA Minutes',
    ecStatus: 'EC Status',
    folderLink: 'Folder Link',
    kml: 'KML',
    remark: 'Remark',
    actions:'Actions'
  };

  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit(): void {
    this.generateDummyData();
  }
    ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  generateDummyData() {
    const data = Array.from({ length: 100 }).map((_, i) => ({
      clientName: `Client ${i + 1}`,
      contactPerson: `Contact ${i + 1}`,
      contactNo: `99999${i}`,
      district: 'Bhopal',
      tehsil: 'Huzur',
      village: 'Malikhedi',
      khasraNo: `K-${i + 1}`,
      area: `${(i + 1) * 1.1} ha`,
      entryDate: '2025-08-01',
      category: i % 2 === 0 ? 'B1' : 'B2',
      ecMp: 'EC Fresh',
      rqp: 'List of RQPs',
      leaseValidity: '2025-2030',
      mpPeriod: '5 Years',
      blasting: i % 2 === 0 ? 'Blasting' : 'Non Blasting',
      mineral: 'Stone',
      fileStatus: 'Running',
      filePreparedBy: 'Shivam',
      productionDetails: '5000 T/year',
      onlineDate: '2025-07-15',
      proposalNo: `PROP-${1000 + i}`,
      caseNo: `CASE-${2000 + i}`,
      seacDate: '2025-07-20',
      pptStatus: 'Recommended',
      seacMinutes: 'Sent to PP',
      seacAdsStatus: 'Hold',
      seacAdsDate: '2025-07-25',
      seiaaDate: '2025-07-30',
      pptApproved: 'Approved',
      seiaaAdsStatus: 'Hold',
      seiaaAgendaDate: '2025-08-01',
      seiaaMinutes: 'Granted',
      ecStatus: 'Granted',
      folderLink: 'https://drive.google.com/folder123',
      kml: 'Uploaded',
      remark: 'No Remarks'
    }));

    this.dataSource.data = data;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
      filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }
}
